import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class DividaServDesligadoService extends Service {
  async consultarEventos () {
    let eventos = await this.getDividaServDesligadoApi().consultarEventos();
    return eventos || [];
  }

  async consultarTipos () {
    let tipos = await this.getDividaServDesligadoApi().consultarTipos();
    return tipos || [];
  }
  async consultarServidoresDesligados () {
    let tipos = await this.getDividaServDesligadoApi().consultarServidoresDesligados();
    return tipos || [];
  }
  async consultarDividas (numMatricula, codEvento, codTipo, dataInicial, dataFinal, apenasSemBaixa) {
    let dividas = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    let result = await this.getDividaServDesligadoApi().consultarDividas(numMatricula, codEvento, codTipo, dataInicial, dataFinal, apenasSemBaixa);
    result.map(res => {
      const { numDivida, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, codEvento, desEvento, codTipo, desTipo, dtaCadastro,	valDivida, txtObservacao, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, valTotalBaixado, baixas, anoProcesso, numProcesso, txtProcessoSei } = res;
      if (codUsuarioCancelamento.trim() !== '') {
        tipoBotaoCancelamento = 'DESFAZER';
      } else {
        tipoBotaoCancelamento = 'CANCELAR';
      }
      dividas.push(Object.values({ numDivida, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, codEvento, desEvento, codTipo, desTipo, dtaCadastro,	valDivida, txtObservacao, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, valTotalBaixado, baixas, tipoBotaoCancelamento, anoProcesso, numProcesso, txtProcessoSei, brancoAcoes }));
    });
    return dividas || [];
  }
  async incluirDivida (divida) {
    let result = await this.getDividaServDesligadoApi().incluirDivida(divida);
    return result;
  }
  async alterarDivida (divida) {
    let result = await this.getDividaServDesligadoApi().alterarDivida(divida);
    return result;
  }
  async excluirDivida (numDivida) {
    let result = await this.getDividaServDesligadoApi().excluirDivida(numDivida);
    return result;
  }
  async cancelarDivida (numDivida, motivoCancelamento) {
    const result = await this.getDividaServDesligadoApi().cancelarDivida(numDivida, motivoCancelamento);
    return result;
  }
  async desfazerCancelamentoDivida (numDivida) {
    const result = await this.getDividaServDesligadoApi().desfazerCancelamentoDivida(numDivida);
    return result;
  }
  async validarDivida (divida) {
    let result = await this.getDividaServDesligadoApi().validarDivida(divida);
    return result || [];
  }
  async baixarAutomaticamente (divida) {
    let result = await this.getDividaServDesligadoApi().baixarAutomaticamente(divida);
    return result || [];
  }
  async compensarCredito (divida) {
    let result = await this.getDividaServDesligadoApi().compensarCredito(divida);
    return result || [];
  }  
}
export default DividaServDesligadoService;
